import React from 'react';

import {useTranslation} from 'common/i18n/hooks';
import {Trans, TranslationKey} from 'common/i18n';

import styles from './index.module.styl';

export type SessionRecordingErrorStateProps = {
  titleKey: TranslationKey;
  subtitleKey: TranslationKey;
  subtitleLink: string;
};

export function SessionRecordingErrorState(props: SessionRecordingErrorStateProps) {
  const {t} = useTranslation();

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateTitle}>{t(props.titleKey)}</div>
      <div className={styles.emptyStateSubtitle}>
        <Trans
          t={t}
          i18nKey={props.subtitleKey}
          components={{
            docsLink: <a href={props.subtitleLink} target={`_blank`} />,
          }}
        />
      </div>
    </div>
  );
}
